import {
  parseReaderDisplaySettings,
  serializeReaderDisplaySettings,
  type ReaderDisplaySettings,
} from './reader-display-settings';

export const READER_DISPLAY_SETTINGS_COOKIE = 'molwe_reader_settings';
const READER_DISPLAY_SETTINGS_MAX_AGE = 60 * 60 * 24 * 365;

let cachedRaw: string | null = null;
let cachedSettings: ReaderDisplaySettings | null = null;
let cacheReady = false;

function readRawReaderSettingsCookie(): string | null {
  if (typeof document === 'undefined') return null;

  const entries = document.cookie.split(';');
  for (const entry of entries) {
    const trimmed = entry.trim();
    if (!trimmed.startsWith(`${READER_DISPLAY_SETTINGS_COOKIE}=`)) continue;
    return trimmed.slice(READER_DISPLAY_SETTINGS_COOKIE.length + 1);
  }
  return null;
}

export function readReaderSettingsCookie(): ReaderDisplaySettings | null {
  const raw = readRawReaderSettingsCookie();
  if (cacheReady && raw === cachedRaw) return cachedSettings;

  cachedRaw = raw;
  cacheReady = true;
  if (!raw) {
    cachedSettings = null;
    return null;
  }

  try {
    cachedSettings = parseReaderDisplaySettings(JSON.parse(decodeURIComponent(raw)));
  } catch {
    cachedSettings = null;
  }
  return cachedSettings;
}

export function writeReaderSettingsCookie(settings: ReaderDisplaySettings): void {
  if (typeof document === 'undefined') return;

  try {
    const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';
    const value = encodeURIComponent(JSON.stringify(serializeReaderDisplaySettings(settings)));
    document.cookie = `${READER_DISPLAY_SETTINGS_COOKIE}=${value}; path=/; max-age=${READER_DISPLAY_SETTINGS_MAX_AGE}; SameSite=Lax${secureFlag}`;
    cacheReady = false;
  } catch {
    // Cookie storage can be blocked; reading still works for this session.
  }
}
